import React, { useState } from 'react';
import {
  Card, Col, Row, Select
} from 'antd';

const IconImg = (props) => (
  <img src={props.name} alt="Vendor Medical Clinic" />
)

const { Option } = Select;
export default function CardComponent(props) {

  const [dropDownClincValue, setDropDownClincValue] = useState('today');

  const cardClinicTitle = (
    <Row className="card-title">
      <Col span={8} className="icon-bg">
        <div><IconImg name={props.OrdersIcon} /></div>
      </Col>
      <Col span={16} className="title-content">
        <>
          {dropDownClincValue === 'today' && (
            <>
              <p>Clinic Consultation</p>
              <span>{props.data.clinic_consultation && props.data.clinic_consultation.today.total_count}</span>
            </>
          )}
          {dropDownClincValue === 'week' && (
            <>
              <p>Clinic Consultation</p>
              <span>{props.data.clinic_consultation && props.data.clinic_consultation.week.total_count}</span>
            </>
          )}
          {dropDownClincValue === 'month' && (
            <>
              <p>Clinic Consultation</p>
              <span>{props.data.clinic_consultation && props.data.clinic_consultation.month.total_count}</span>
            </>
          )}
        </>
      </Col>
    </Row>
  )
  const clinicDropdown = (
    <span className='select-button'>
      <Select defaultValue="today" style={{ width: 111 }} onChange={(value) => setDropDownClincValue(value)}>
        <Option value="today">Today</Option>
        <Option value="week">This Week</Option>
        <Option value="month">This Month</Option>
      </Select>
    </span>
  )

  return (
    props.data ? (
      <Card bordered={false} title={cardClinicTitle} className='dashboard-card' extra={clinicDropdown}>
        {dropDownClincValue === 'today' && (
          <>
            <p className='card-component-content'>Completed: <span>{props.data.clinic_consultation.today.completed}</span></p>
            <p className='card-component-content'>Cancelled: <span>{props.data.clinic_consultation.today.cancelled}</span></p>
            <p className='card-component-content'>New Booking: <span>{props.data.clinic_consultation.today.new}</span></p>
          </>
        )}
        {dropDownClincValue === 'week' && (
          <>
            <p className='card-component-content'>Completed: <span>{props.data.clinic_consultation.week.completed}</span></p>
            <p className='card-component-content'>Cancelled: <span>{props.data.clinic_consultation.week.cancelled}</span></p>
            <p className='card-component-content'>New Booking: <span>{props.data.clinic_consultation.week.new}</span></p>
          </>
        )}
        {dropDownClincValue === 'month' && (
          <>
            <p className='card-component-content'>Completed: <span>{props.data.clinic_consultation.month.completed}</span></p>
            <p className='card-component-content'>Cancelled: <span>{props.data.clinic_consultation.month.cancelled}</span></p>
            <p className='card-component-content'>New Booking: <span>{props.data.clinic_consultation.month.new}</span></p>
          </>
        )}
      </Card>
    ) : null
  );
}
